<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <!-- Container wrapper -->
  <div class="container-fluid">
    <button #sidenavToggle class="btn shadow-0" type="button" (click)="sidenav.toggle()"
      aria-controls="navbarToggleExternalContent" aria-expanded="false" aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>
    <!-- Navbar brand
    <a class="navbar-brand" href="#">Brand</a>
 -->
    <!-- Toggle button -->
    <button class="navbar-toggler" type="button" (click)="basicNavbar.toggle()" aria-expanded="false"
      aria-label="Toggle navigation">
      <i class="fas fa-bars"></i>
    </button>

    <!-- Collapsible wrapper -->
    <div class="d-flex align-items-center">
      <div class="collapse navbar-collapse" id="navbarSupportedContent" mdbCollapse #basicNavbar="mdbCollapse">
        <ul class="navbar-nav me-auto mb-2 ms-2 ps-1 ms-lg-0 ps-lg-0 mb-lg-0">
          <li class="nav-item navbar-toggler">

          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Dashboard</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Team</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Projects</a>
          </li>
        </ul>
      </div>
      <button *ngIf="!loggato" type="button" class="btn btn-link px-3 mb-1 me-2" [routerLink]="['login']">
        Accedi
      </button>

      <button *ngIf="!loggato" type="button" class="btn btn-primary mb-1 me-lg-3">
        Registrati 
      </button>
      <button *ngIf="loggato" type="button" class="btn btn-link px-3 mb-1 me-2" (click)="logout()">
        Logout</button>
    </div>
  </div>
</nav>


<mdb-sidenav-layout>
  <mdb-sidenav [mode]="'side'" [accordion]="'true'" #sidenav="mdbSidenav" [hidden]="false">
    <a class="d-flex justify-content-center py-4" mdbRipple rippleColor="success" style="min-width: 200px">
      <img id="logo" src="assets/logo_tf.jpg" alt="Logo" width="100" draggable="false" />
    </a>
    <ul class="sidenav-menu">
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="far fa-smile fa-fw me-3"></i>
          <span>Asian Breakout</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/asia-bo']">Breakout</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/asiabo-ct']">Breakout CrossTrend</a>
          </li>          
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="far fa-smile fa-fw me-3"></i><span>CrossOver</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crossover-analisi']">Analisi</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crossover-analisi-m45']">Analisi M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crossover-analisi-h1']">Analisi H1</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/ultimi-valori-m15']">Ultimi Valori M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/ultimi-valori-h1']">Ultimi Valori H1</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/ultimi-valori-h4']">Ultimi Valori H4</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crossover-xau']">XAU M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crossover-xau-h1']">XAU H1</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="far fa-smile fa-fw me-3"></i><span>CrossTrend</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend-backtest-m15']">Backtest M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend-backtest-h1']">Backtest H1</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend-backtest-h4']">Backtest H4</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/cross-trend-h1']">Analisi H1</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="far fa-smile fa-fw me-3"></i><span>CrossTrend2</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend2-backtest-m15']">Backtest M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend2-backtest-h1']">Backtest H1</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/crosstrend2-backtest-h4']">Backtest H4</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="far fa-smile fa-fw me-3"></i><span>Donchian</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/donchian/ultimi-m15']">Ultimi M15</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/donchian/ultimi-h1']">Ultimi H1</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/donchian/ultimi-h4']">Ultimi H4</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=7">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-beam fa-fw me-3"></i><span>Dax Trend</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/dax-trend']">Impostazioni</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>Daily High-Low</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['daily-hilo']">Analisi</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['hilo-backtest']">Backtest completo</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['hilo-dinamic-backtest']">Backtest dinamico 1 anno</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['hilo-update']">Update</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" [routerLink]="['/simulator']" tabindex="0">Simulatore</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" [routerLink]="['/daily-preferiti']" tabindex="1">Preferiti</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" [routerLink]="['/daily-operative']" tabindex="2">Operative</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>Reverse</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/reverse-m45']">M45</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>AntiMartingala</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/antimartingala']">Gestione Operazioni</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0">Link 8</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <mdb-sidenav-item *ngIf="utente.gerarchia<=1">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin fa-fw me-3"></i><span>FracTime</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/storico']">Storico</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/analisi-ts']">Analisi TS</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" [routerLink]="['/backtester']" tabindex="0">Backtester</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/selezionati']">Selezionati</a>
          </li>
        </ul>
      </mdb-sidenav-item>

      <mdb-sidenav-item *ngIf="utente.gerarchia==0">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>Gestione Utenti</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/nuovo-utente']">Nuovo</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/lista-utenti']">Lista</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/gruppi-utenti']">Gruppi</a>
          </li>
        </ul>
      </mdb-sidenav-item>

      <mdb-sidenav-item *ngIf="utente.gerarchia<3">
        <a class="sidenav-link" tabindex="0">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>Gestione Report</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/accounts']">Accounts</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/nuovo-report']">Nuovo Report</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0" [routerLink]="['/lista-report']">Lista</a>
          </li>
        </ul>
      </mdb-sidenav-item>
      <!-- <mdb-sidenav-item>
        <a class="sidenav-link">
          <i class="fas fa-grin-wink fa-fw me-3"></i><span>Category 2</span>
        </a>
        <ul class="sidenav-collapse" mdbCollapse>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0">Link 4</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link" tabindex="0">Link 5</a>
          </li>
        </ul>
      </mdb-sidenav-item> -->

      <mdb-sidenav-item *ngIf="utente.gerarchia<=3">
        <a class="sidenav-link" tabindex="0" [routerLink]="['update']">
          <i class="fas fa-grin-wink fa-fw me-3"></i>
          Update
        </a>
      </mdb-sidenav-item>
    </ul>

  </mdb-sidenav>

  <mdb-sidenav-content #sidenavContent>
    <router-outlet></router-outlet>

  </mdb-sidenav-content>
</mdb-sidenav-layout>